import { z } from 'zod';

import { isoDateTimeSchema, uuidSchema } from './common.js';

const hoursSchema = z.coerce
  .number()
  .min(0, 'Часы не могут быть отрицательными')
  .max(9999, 'Слишком много часов');

export const projectSchema = z.object({
  id: uuidSchema,
  /** Public numeric id — used in browser URLs (/projects/100000042). */
  number: z.number().int().positive(),
  clientId: uuidSchema,
  name: z.string().min(1).max(200),
  timeHours: hoursSchema,
  archived: z.boolean(),
  /** `YYYY-MM` when this row is a monthly done-task snapshot; null on live projects. */
  archiveMonthKey: z.string().regex(/^\d{4}-\d{2}$/).nullable(),
  /** Live project this snapshot was split from. */
  sourceProjectId: uuidSchema.nullable(),
  sortOrder: z.number().int(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});
export type ProjectDto = z.infer<typeof projectSchema>;

export const createProjectSchema = z.object({
  clientId: uuidSchema,
  name: z.string().min(1, 'Введите название проекта').max(200),
  timeHours: hoursSchema.default(0),
});
export type CreateProjectDto = z.infer<typeof createProjectSchema>;

export const updateProjectSchema = z
  .object({
    name: z.string().min(1).max(200),
    timeHours: hoursSchema,
    archived: z.boolean(),
    sortOrder: z.number().int(),
  })
  .partial();
export type UpdateProjectDto = z.infer<typeof updateProjectSchema>;

export const projectTaskSummarySchema = z.object({
  projectId: uuidSchema,
  taskCount: z.number().int().min(0),
  openCount: z.number().int().min(0),
  factHours: hoursSchema,
});
export type ProjectTaskSummaryDto = z.infer<typeof projectTaskSummarySchema>;

export const projectTaskSummaryListSchema = z.object({
  summaries: z.array(projectTaskSummarySchema),
});
export type ProjectTaskSummaryListDto = z.infer<typeof projectTaskSummaryListSchema>;
